"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createAssigner = _interopRequireDefault(require("./_createAssigner.js"));

var _allKeys = _interopRequireDefault(require("./allKeys.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Fill in a given object with default properties.
var _default = (0, _createAssigner.default)(_allKeys.default, true);

exports.default = _default;